import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './ScheduleDetails.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

class ScheduleDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purposes : [],
      purpose : {},
      complaint : '',
      activity : '',
      outstanding : 0,
      exe_schedule : {},
      address : '',
      enquiry_list : [],
      selectedEnquiry : ''
    }
    this.formChange = this.formChange.bind(this);
  }

  componentDidMount(){   
    const url = `${process.env.REACT_APP_SSS}/api/getScheduleDetails`;
    this.context.loading(1);
    var obj_this = this;
    if(typeof geo !== 'undefined'){
      geo.getLocation(function(location){
        if(!location || !location.latitude) {
            obj_this.context.loading(0);
            return;
        }
        obj_this.context.setLocation(location);
        const  url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+location.latitude+','+location.longitude+'&key='+process.env.REACT_APP_GOOGLE_MAP_API_KEY;
          $.ajax({
            url : url,
            type : "GET"
          }).done(function(return_data){
            // console.log(return_data);
            if(return_data.status == "OK" && return_data.results[0]){
              obj_this.setState({
                address : return_data.results[0].formatted_address
              });
              obj_this.context.loading(0);
            }else{
              obj_this.context.loading(0);
              alert("Couldn't fetch your address");
            }
          });
      });
    }

    $(".location_button").on("click",function(){
      if(typeof geo !== 'undefined'){
        var location_coordinates = obj_this.context.location;
        geo.getLocation(function(location){
          if(!location || !location.latitude) {
              obj_this.context.loading(0);
              return;
          }
          location_coordinates = location;
          obj_this.context.setLocation(location);
          obj_this.context.loading(0);
          const  url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='+location_coordinates.latitude+','+location_coordinates.longitude+'&key='+process.env.REACT_APP_GOOGLE_MAP_API_KEY;
          $.ajax({
            url : url,
            type : "GET"
          }).done(function(return_data){
            // console.log(return_data);
            if(return_data.status == "OK" && return_data.results[0]){
              obj_this.setState({
                address : return_data.results[0].formatted_address
              });
              obj_this.context.loading(0);
            }else{
              obj_this.context.loading(0);
              alert("Couldn't fetch your address");
            }
          });
          }
          )};
    });
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        schedule_id : this.props.match.params.sched_id,
        edit_schedule_id : this.props.match.params.edit_sched_id,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          purposes : return_data.purposes,
          outstanding : return_data.outstanding,
          sales : return_data.sales,
          exe_schedule : return_data.exe_schedule,
          purpose : return_data.purpose,
          complaint : return_data.exe_schedule.complaint??'',
          activity : return_data.exe_schedule.activity??'',
          enquiry_list : return_data.enquiry_list,
          address : return_data.exe_schedule.location,
          selectedEnquiry : parseInt(return_data.exe_schedule.enquiry)
        });
        if(!return_data.purpose?.label){
          let purpose = obj_this.props.location.state && obj_this.props.location.state.purposeOfVisit
          // console.log(purpose);
          // alert(purpose);
          obj_this.setState({
            purpose : purpose
          })
        }
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });   
  }

  purposeChange(option) {
    this.setState({
      purpose: option
    });
  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }
  handleRadioChange = (selectedEnquiryId) => {
    this.setState({ selectedEnquiry: selectedEnquiryId });
    // console.log(selectedEnquiryId);
  };

  formSubmit(e){
    e.preventDefault();
    if(!this.state.purpose.value){
       this.refs.focus();
      return;
    }
    // console.log(this.state);
    // return;
    var obj_this = this;
    var location_coordinates = this.context.location;
    if(typeof geo !== 'undefined'){
      if(!location_coordinates.latitude){
        if(!confirm("Submit without location coordinates")){
          geo.getLocation(function(location){
            if(location && location.latitude) location_coordinates = location;
          });
        }
      }
    }
    const url = `${process.env.REACT_APP_SSS}/api/saveScheduleDetails`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        schedule_id : this.props.match.params.sched_id,
        purpose : this.state.purpose.value,
        complaint : this.state.complaint,
        activity : this.state.activity,
        outstanding : this.state.outstanding,
        sales : this.state.sales,
        location : location_coordinates,
        edit_schedule_id : this.props.match.params.edit_sched_id,
        address : this.state.address??"",
        selectedEnquiry : this.state.selectedEnquiry??null

      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "success"){
        alert("Schedule details updated");
        obj_this.props.history.replace('/schedules');
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  render(){
    const { history, location } = this.props;
    let collectionData;
    let salesData;
    if (location.state && location.state.from == "collection") {
      collectionData = location.state?.collectionData
    }
    if (location.state && location.state.from == "salesorder") {
      salesData = location.state?.salesData
      let purposeOfVisit = location.state?.purposeOfVisit
    }
    if (location.state && location.state.from == "enquiry") {
      // salesData = location.state?.salesData
      let purposeOfVisit = location.state?.purposeOfVisit
      console.log(location.state)
    }
  return (
    <MyContext.Consumer>
      {context => (
        <div className="schedule_details_page_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Schedule</div>
          </div>
          <div className="customer_details">
            <div className="customer_name">{this.state.exe_schedule.customer_name}</div>
            <div className="outstanding_sales_container" style={{display:this.state.exe_schedule.customer_type=="D"?"grid":"none"}}>
              <div className="outstanding">
                <div className="amount">{this.context.currency} {this.state.outstanding}</div>
                <div className="label">Outstanding</div>
              </div>
              <div className="sales">
                <div className="amount">{this.context.currency} {this.state.sales}</div>
                <div className="label">Sales</div>
              </div>
            </div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="schedule_details_container blocks">
              <div className="input_label">Purpose of visit</div>
              <Select 
                className="purposes" 
                ref={r => {
                  this.refs = r;
                }}
                placeholder={""}
                options= {this.state.purposes}
                value={this.state.purpose}
                onChange={e => this.purposeChange(e)}
                required
              />
              {this.state.exe_schedule?.customer_type=="D"?
              <>
              <div className="collection_sales_button">
                {this.state.purpose?.value == 278?
                  <Link to={{ pathname: '/collections/new',
                              state: {
                                from: 'schedule',
                                schedule_id : this.state.exe_schedule.id,
                                customer_id : this.state.exe_schedule.customer_id,
                                purposeOfVisit : this.state.purpose,

                              }
                            }} ><img className="company_logo"  src={window.project_path+"/dashboard/addCollection.png"} height="100px;" /></Link>:''}

                {this.state.purpose?.label == "SALES"?
                  <Link to={{ pathname: '/salesorders/new',
                                state: {
                                  from: 'schedule',
                                  schedule_id :  this.state.exe_schedule.id,
                                  customer_id : this.state.exe_schedule.customer_id,
                                  purposeOfVisit : this.state.purpose
                                }
                              }} >
                                <img className="company_logo"  src={window.project_path+"/dashboard/addSalesOrder.png"} height="100px;" />
                              </Link>
                              :''}
              
              </div>
              <div>
                <span style={{display:collectionData?"block":"none"}} className="input_label"> Collection Received : {this.context.currency} {collectionData?.amount}</span>
                <span style={{display:salesData?"block":"none"}} className="input_label"> Sale : {this.context.currency} {salesData?.grand_total}</span>

              </div>
              </>:null}
              {this.state.exe_schedule?.customer_type=="L" && this.state.exe_schedule?.enquiry_list?.length>0?
              <div className="schedule_details_container blocks">

                <div className="input_label">
                    Enquiry List
                </div>
                <table className="leads_enquiry_list_table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Enq No</th>
                      <th>Enq Date</th>
                      <th>Enq Status</th>
                      <th>Action</th>

                    </tr>
                  </thead>
                  <tbody>
                {this.state.exe_schedule?.enquiry_list?.map((item,idx)=>(    
                    <tr>
                        <td style={{textAlign:"center"}}>        
                          <input
                            type="radio"
                            name="selectedEnquiry"
                            className="custom_radio"
                            value={item.id}
                            checked={this.state.selectedEnquiry === item.id}
                            onChange={(e) => this.handleRadioChange(item.id)}
                          />
                          
                        </td>
                        <td>{item.enq_no}</td> 
                        <td style={{textAlign:"center"}}>{new Date(item.enq_date).toLocaleDateString('en-GB')}</td> 
                        <td style={{textAlign:"center"}}>{item.enquiry_status}</td>                     
                        <td>
                        <Link to={{ pathname: '/leads/edit/'+item.id,
                              state: {
                                from: 'schedule',
                                schedule_id :  this.state.exe_schedule.id,
                                customer_id : this.state.exe_schedule.customer_id,
                                enquiry_id : item.id,
                                purposeOfVisit : this.state.purpose
                              }
                            }} >
                                <div style={{ width: '100%',textAlign:'center' }}>
                                <i className="fa fa-arrow-right arrow-gotobutton"></i>

                                </div>
                        </Link>                        
                        </td>
                      </tr>                   
                  ))}
                  </tbody>
                </table>
              </div>
               :''}
              <div className="input_label">Complaint if any</div>
              <input className="complaint input custom_input"
                type="text"
                name="complaint"
                value={this.state.complaint}
                onChange={this.formChange}
                autoComplete="off"
              />
              <div className="input_label">Activity</div>
               <textarea className="input activity custom_input" 
                name="activity"
                value={this.state.activity}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              { (this.state.exe_schedule.check_inout =='IN' || this.state.exe_schedule.check_inout =='') && <>
                <div className="input_label">Location coordinates</div>
                <div className="location_container">
                  <input className="complaint input custom_input"
                    type="text"
                    name="location"
                    value={this.context.location.latitude+", "+this.context.location.longitude}
                    onChange={this.formChange}
                    autoComplete="off"
                    disabled
                  />
                  <div className="location_button">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                </div>
              </>

              }
              <div>
              
                  <div className="input_label">Current Address</div>
                  <div className="location_container">
                    <textarea 
                      className="location input"
                      name = "address"
                      value = {this.state.address}
                      onChange = {this.formChange}
                      disabled
                      required
                    />
                  </div>
              </div>
            </div>
            {this.state.exe_schedule.check_inout=="IN"?
            <button type="submit" 
              className="submit_button"
            >
              <i className="far fa-save"></i> {this.state.exe_schedule.check_inout=="IN"?"CHECK OUT":"UPDATE"}
            </button>:''}
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default ScheduleDetails;
ScheduleDetails.contextType = MyContext;
